import { useAxios } from "@vueuse/integrations/useAxios";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";
import http from "@/common/utils/http-common-utils";
import type { ApiMedicalMenuCategoryIndexReq, ApiMedicalMenuCategoryReq } from "@/clinic/typings";

const ServiceTagService = {
  fetchServiceTag: async (params: any) => {
    const { execute } = useAxios(ApiRouterConstants.API_SERVICE_TAGS, { method: "GET", params: params }, http, {
      immediate: false,
    });
    return await execute();
  },
  saveServiceTag: async (params: any, data: any, onSuccess: () => void, onError: (errors: any) => void) => {
    let url = ApiRouterConstants.API_SERVICE_TAGS;
    if (params.id) url = `${url}/${params.id}`;
    const method = params.id ? "PUT" : "POST";

    const { execute } = useAxios(url, { method: method, params: params, data: data }, http, {
      immediate: false,
      onSuccess: () => onSuccess(),
      onError: (errors: any) => onError(errors.response?.data),
    });
    return await execute();
  },
  destroyServiceTag: async (id: any, params: any) => {
    const { execute } = useAxios(
      `${ApiRouterConstants.API_SERVICE_TAGS}/${id}`,
      { method: "DELETE", params: params },
      http,
      {
        immediate: false,
      }
    );
    return await execute();
  },
};

export default ServiceTagService;
